module.exports = __webpack_public_path__ + "static/media/logo.7ac6518b.png";